import DoAPICall from './DoAPICall'

//Create complaint
export async function createComplaint(userToken, Complaint){
	const apiPayload = {
		httpMethod:'post',
		userToken,
		uri:'complaints',
		payLoad:{
			complaint_subtype_id:Complaint.complaint_subtype_id,
			client_id:Complaint.client_id,
			customerAccount:Complaint.customerAccount,
			mobileNumber:Complaint.mobileNumber,
			revenuePoint:Complaint.revenuePoint,
			address:Complaint.address,
			details:Complaint.details,
			status:Complaint.status
		},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All complaint
export async function getComplaints(userToken){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complaints',
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get All complaint
export async function getComplaintsOfClient(userToken,params){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complaintsofclient?dateFrom='+params.from+'&dateTo='+params.to,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

export async function getClosedComplaintsOfClient(userToken,params){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'closedcomplaintsofclient?dateFrom='+params.from+'&dateTo='+params.to,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

export async function getClientComplaintsDashboard(userToken,params){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'clientcomplaintsdashboard?dateFrom='+params.from+'&dateTo='+params.to+'&client_id='+params.client_id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

export async function getMainComplaintsMainDashboard(userToken,theMonth){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'maincomplaintsdashboard?theMonth='+theMonth,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Get One complaint
export async function getComplaint(userToken, id){
	const apiPayload = {
		httpMethod:'get',
		userToken,
		uri:'complaints/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Update complaint
export async function updateComplaint(userToken, Complaint,status){
	const apiPayload = {
		httpMethod:'put',
		userToken,
		uri:'complaints/'+Complaint.id,
		payLoad:{
				resolution:Complaint.resolution,
				comments:Complaint.comments,
				status
			},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}

//Delete complaint
export async function deleteComplaint(userToken, id){
	const apiPayload = {
		httpMethod:'delete',
		userToken,
		uri:'complaints/'+id,
		payLoad:{},
		requestOptions:{}
	}
	return await DoAPICall(apiPayload)
}